import { render, staticRenderFns } from "./AssociateButton.vue?vue&type=template&id=1cce86f8&"
import script from "./AssociateButton.vue?vue&type=script&lang=js&"
export * from "./AssociateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports